export default function invite(email: string) {
  return fetch(`${window.graphqlEndpoint}/employee_activations`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email }),
  }).then((response) => response.json())
}
